<template>
  <div class="m-l-50 m-t-30 w-500">
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="流程名称" prop="name">
        <el-input v-model.trim="form.name" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="流程图标" prop="icon" class="pos-rel">
        <selectIcon v-show="iconShow" @selectOneIcon="getSelectedIcon"></selectIcon>
        <div class="w-30 h-30 pointer" :class="iconSelected" @click="openIcon"></div>
        <el-input v-model.trim="form.icon" class="hide"></el-input>
      </el-form-item>
      <el-form-item label="是否常用">
        <el-radio class="radio" v-model="form.is_used" :label="0">否</el-radio>
        <el-radio class="radio" v-model="form.is_used" :label="1">是</el-radio>
      </el-form-item>
      <el-form-item label="编号前缀" prop="num_prefix">
        <el-input v-model.trim="form.num_prefix" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="数据管理用户组" prop="manage_group">
        <el-select v-model="form.manage_group" multiple placeholder="请选择数据管理用户组" class="w-200">
          <el-option v-for="item in groups" :label="item.else" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="流程分类" prop="type_id">
        <el-select v-model="form.type_id" placeholder="请选择流程分类" clearable class="w-200">
          <el-option v-for="item in typeOption" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="流程描述" prop="description">
        <el-input v-model.trim="form.description" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" class="w-200"></el-input>
      </el-form-item>
      <el-form-item label="关联表单" prop="model_id">
        <el-select v-model="form.model_id" placeholder="请选择关联表单" class="w-200">
          <el-option v-for="item in models" :label="item.title + '(' + item.name + ')'" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="允许发起人" prop="allow_uid">
        <el-select v-model="form.allow_uid" multiple placeholder="请选择">
          <el-option v-for="item in users" :label="item.realname" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="允许发起部门" prop="allow_struct">
        <el-select v-model="form.allow_struct" multiple placeholder="请选择">
          <el-option v-for="item in structs" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="允许发起用户组" prop="allow_group">
        <el-select v-model="form.allow_group" multiple placeholder="请选择">
          <el-option v-for="item in groups" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="实例命名方式" prop="case_config">
        <div>
          <span v-for="(item, index) in form.case_config">
            <span v-if="index != 0"> - </span>{{ filterCaseName(item) }}
          </span>
        </div>
        <el-select v-model="form.case_config" multiple placeholder="请选择">
          <el-option v-for="item in caseOption" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add()" :loading="isLoading">提交</el-button>
        <el-button @click="goback()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import http from '../../../assets/js/http'
  import selectIcon from './selectIcon.vue'

  export default {
    data() {
      return {
        isLoading: false,
        iconShow: false,
        rules: {
          name: [
            { required: true, message: '请输入流程名称' }
          ],
          type_id: [
            { required: true, message: '请选择流程分类' }
          ],
          // manage_uid: [
          //   { required: true, message: '请选择数据管理用户组' }
          // ],
          manage_group: [
            { required: true, message: '请选择数据管理用户组' }
          ],
          description: [
            { required: true, message: '请输入流程描述' }
          ],
          // allow_uid: [
          //   { required: true, message: '请选择允许发起人' }
          // ],
          // allow_struct: [
          //   { required: true, message: '请选择允许发起部门' }
          // ],
          model_id: [
            { required: true, message: '请选择动态表单模型' }
          ],
          case_config: [
            { required: true, message: '请选择实例命名方式' }
          ],
          num_prefix: [
            { required: true, message: '请填写流程编号前缀' }
          ]
        },
        form: {
          name: '',
          icon: 'icon-office',
          is_used: 0,
          manage_uid: null,
          manage_group: [],
          type_id: '',
          description: '',
          allow_uid: [],
          allow_struct: [],
          allow_group: [],
          model_id: '',
          case_config: [],
          num_prefix: ''
        },
        typeOption: [],
        users: [],
        groups: [],
        structs: [],
        models: [],
        caseOption: [
          { id: 'tableName', name: '表单名称' },
          { id: 'creatorName', name: '申请人名称' },
          { id: 'createTimeYear', name: '申请时间（年）' },
          { id: 'createTimeMonth', name: '申请时间（月）' },
          { id: 'createTimeDay', name: '申请时间（日）' },
          { id: 'createTimeMin', name: '申请时间（分）' }
        ]
      }
    },
    created() {
      this.getClassify()
      this.getUsers()
      this.getGroups()
      this.getStructs()
      this.getModels()
    },
    methods: {
      filterCaseName(id) {
        let name = null
        _(this.caseOption).forEach((res) => {
          if (res.id == id) {
            name = res.name
            return
          }
        })
        return name
      },
      getModels() {
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('form/models', postData).then((res) => {
          if (res.code == 200) {
            this.models = res.data.list
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getUsers() {
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('admin/users', postData).then((res) => {
          if (res.code == 200) {
            this.users = res.data.list
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getGroups() {
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('admin/groups', postData).then((res) => {
          if (res.code == 200) {
            this.groups = res.data
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getStructs() {
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('admin/structures', postData).then((res) => {
          if (res.code == 200) {
            this.structs = res.data
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getClassify() {
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('bpm/types', postData).then((res) => {
          if (res.code == 200) {
            this.typeOption = res.data.list
          } else {
            _g.dealError(this, res)
          }
        })
      },
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            let postData = JSON.parse(JSON.stringify(this.form))
            this.apiPost('bpm/flows', postData).then((res) => {
              if (res.code == 200) {
                _g.toastMsg(this, 'success', '添加成功')
                // 访问菜单，更新菜单
                _g.updateMenus()
                setTimeout(() => {
                  this.goback()
                }, 1500)
              } else {
                this.isLoading = !this.isLoading
                _g.dealError(this, res)
              }
            })
          }
        })
      },
      goback() {
        router.go(-1)
      },
      openIcon() {
        this.iconShow = !this.iconShow
      },
      getSelectedIcon(val) {
        this.form.icon = val
        this.iconShow = false
      }
    },
    computed: {
      iconSelected() {
        return this.form.icon
      }
    },
    components: {
      selectIcon
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// add.vue?9a7b19be